import tools from "@/utils/tools"

export default class AppUser {
  #userID  // ДОБАВЛЯЕМ
  #cargoTypeID
  #cargoTypeName
  #name
  #shortName
  #role
  #permissions

  constructor({ userId, name, cargoTypeID, cargoTypeName, role, permissions }) {
    this.#userID = userId  // СОХРАНЯЕМ
    this.#cargoTypeID = cargoTypeID
    this.#cargoTypeName = cargoTypeName
    this.#name = name
    this.#shortName = tools.shortFIO(name)
    this.#role = role
    this.#permissions = permissions
  }

  // ДОБАВЛЯЕМ ГЕТТЕРЫ
  get userID() {
    return this.#userID
  }

  get name() {
    return this.#name
  }

  get shortName() {
    return this.#shortName
  }

  get role() {
    return this.#role
  }

  get cargoTypeID() {
    return this.#cargoTypeID
  }

  get cargoTypeName() {
    return this.#cargoTypeName
  }

  get anyCargoType() {
    return !this.#cargoTypeID
  }

  havePermission(permission) {
    return this.#permissions.some(x => x === permission)
  }
}